import React from 'react'
import { FormControl } from 'react-bootstrap'

export const SearcherByExtension = props => {

    const {
        value,
        handleInputChange
    } = props;

    return (
        <FormControl
            required
            placeholder="Buscar por extension"
            type="number"
            name="buscar"
            value={value}
            onChange={handleInputChange}
        />
    )
}
